import { FC, useState } from "react";
import Stack from "@mui/material/Stack";
import { GridApi } from "ag-grid-community";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Typography } from "@mui/material";
import { useEffectOnceWhen } from "rooks";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";
import { AGGridColumnsToolPanel } from "@/components/pages/common/ag-grid/components/AGGridColumnsToolPanel";
import { AgGridGlobalSearch } from "@/components/pages/common/ag-grid/components/global-search/AgGridGlobalSearch";

interface DimensionsAgGridToolbarProps {
  gridApi: GridApi | null;
}

export const DimensionsAgGridToolbar: FC<DimensionsAgGridToolbarProps> = ({
  gridApi,
}) => {
  const [dimensionsCount, setDimensionsCount] = useState(0);

  useEffectOnceWhen(() => {
    const calculateDimensionsCount = () => {
      let totalRows = 0;

      gridApi?.forEachNodeAfterFilterAndSort((node) => {
        if (!node.group) {
          return;
        }

        totalRows++;
      });

      setDimensionsCount(totalRows);
    };

    calculateDimensionsCount();
    gridApi?.addEventListener("rowDataUpdated", calculateDimensionsCount);
    gridApi?.addEventListener("filterChanged", calculateDimensionsCount);

    return () => {
      gridApi?.removeEventListener("rowDataUpdated", calculateDimensionsCount);
      gridApi?.removeEventListener("filterChanged", calculateDimensionsCount);
    };
  }, !!gridApi);

  return (
    <Stack
      p={1}
      pl={2}
      bgcolor="white"
      direction="row"
      borderBottom={1}
      alignItems="center"
      borderColor="grey.300"
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2">
          {dimensionsCount} Dimension{dimensionsCount > 1 ? "s" : ""}
        </Typography>

        <AgGridAllFiltersChip gridApi={gridApi} />
      </Stack>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={2}
      >
        <AgGridGlobalSearch
          sx={{ width: 260 }}
          gridApi={gridApi}
          InputProps={inputProps}
        />

        <AGGridColumnsToolPanel gridApi={gridApi} />
      </Stack>
    </Stack>
  );
};

const inputProps = {
  sx: {
    height: 36,
  },
  startAdornment: (
    <InputAdornment position="start">
      <SearchIcon />
    </InputAdornment>
  ),
};
